import { Link } from 'react-router-dom';

/**
 * Site footer, ported from footer.php. The site has no visible navbar (the
 * original header nav was commented out), so this footer is the primary
 * navigation. Home-page section links use hash anchors that resolve on the
 * front page.
 */
export default function Footer() {
  return (
    <footer className="text-center row text-lg-start footer-bg pt-5 pb-5">
      <section>
        <div className="container text-center">
          <div className="row">
            <div className="col-4">
              <h6 className="text-uppercase fw-bold mb-4">
                <Link to="/#hpHome">Logan Holmes Runs</Link>
              </h6>
              <p>
                A website for all information about my running. Stay up to date on the races I have
                coming up and read my recaps of previous races. Also keep up with my training
                through my runs and my blog!
              </p>
            </div>

            <div className="col-4">
              <h6 className="text-uppercase fw-bold mb-4">Site Map</h6>
              <p>
                <Link to="/#hpHome" className="text-reset">
                  Home
                </Link>
              </p>
              <p>
                <Link to="/#randomMapContainer" className="text-reset">
                  Random Runs
                </Link>
              </p>
              <p>
                <Link to="/#hpRaces" className="text-reset">
                  Races
                </Link>
              </p>
              <p>
                <Link to="/#hpRecentRuns" className="text-reset">
                  Recent Runs
                </Link>
              </p>
              <p>
                <Link to="/#hpBlog" className="text-reset">
                  Blog
                </Link>
              </p>
              <p>
                <Link to="/#allRunsMap" className="text-reset">
                  Run Map
                </Link>
              </p>
            </div>

            <div className="col-4">
              <h6 className="text-uppercase fw-bold mb-4">Socials</h6>
              <p>
                <br />
              </p>
              <p>
                <a
                  href="https://twitter.com/realbiglogan"
                  target="_blank"
                  rel="noreferrer"
                  className="text-reset"
                >
                  <i className="fa-brands fa-twitter fa-2xl"></i>
                </a>
              </p>
              <p>
                <br />
              </p>
              <p>
                <a
                  href="https://www.instagram.com/realloganholmes/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-reset"
                >
                  <i className="fa-brands fa-instagram fa-2xl"></i>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
}
